<nav
  class="tabs"
  [ngClass]="[variant, fullWidth ? 'full-width' : '']"
  >
  @for (tab of tabs; track trackById($index, tab)) {
    <button
      type="button"
      class="tab-item"
      [id]="tab.id"
      [class.active]="isActive(tab)"
      [class.disabled]="tab.disabled"
      (click)="onTabClick(tab)"
      >
      <span class="tab-content">
        @if (tab.icon) {
          <fa-icon
            class="tab-icon"
            [icon]="tab.icon">
          </fa-icon>
        }
        <span class="tab-label">
          {{ tab.label | translate }}
        </span>
        @if (tab.badge !== undefined && tab.badge !== null) {
          <span
            class="tab-badge">
            {{ tab.badge }}
          </span>
        }
        @if (tab.showHelp) {
          <button 
            type="button"
            class="help-btn"
            (click)="onHelpClick($event, tab.id)"
            title="Ajuda">
            <fa-icon [icon]="faQuestionCircle"></fa-icon>
          </button>
        }
      </span>
      @if (variant === 'underline') {
        <span class="active-indicator"></span>
      }
    </button>
  }
</nav>
